enum EnumGender {
    Female = 1,
    Male,
    Other
}

export { EnumGender };
